import axiosInstance from './axiosInstance'

export const getProjectSectionTaskById = (taskId, refData = false) => {
  return axiosInstance.get(`/project/section-tasks/${taskId}?refData=${refData}`)
}

export const getProjectSectionTasksBySectionId = (sectionId) => {
  return axiosInstance.get(`/project/section-tasks?sectionId=${sectionId}`)
}

export const createProjectSectionTask = (data) => {
  return axiosInstance.post('/project/section-tasks', data)
}

export const updateProjectSectionTask = (taskId, data) => {
  return axiosInstance.put(`/project/section-tasks/${taskId}`, data)
}

export const deleteProjectSectionTask = (taskId) => {
  return axiosInstance.delete(`/project/section-tasks/${taskId}`)
}

export const completeProjectSectionTask = (taskId, isCompleted = true) => {
  return axiosInstance.get(`/project/section-tasks/${taskId}/complete?isCompleted=${isCompleted}`)
}
